import React, { useState } from 'react'

import FormBlock from 'components/Forms/FormBlock'
import FormModal from 'components/Modal/FormModal/FormModal'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'
import Input from 'components/Forms/Input/Input'
import Checkbox from 'components/Forms/Checkbox/Checkbox'

import { RUSSIAN_CURRENCY } from 'constants/currencies'

import { fieldsValidator, getIsIntStringRule, getIsNotEmptyStringRule, getIsValueRule } from 'utils/fieldsValidator'
import { removeKeyFromObject } from 'utils/common'
import { getYearlyFormattedPrice } from 'utils/payments'

import styles from './AddPriceModal.module.scss'

const PriceNote = ({ price, currency, billingCycle }) => {
    if (billingCycle !== 12) return null

    return (
        <div className={styles.priceNote}>
            <span className={styles.price}>{getYearlyFormattedPrice(price, currency, 1)}</span> / year
        </div>
    )
}

const AddPriceModal = ({ currenciesSymbol, payload: { product, currency }, onSubmit, onClose }) => {
    const [isNeedToConfirm] = useState(currency !== RUSSIAN_CURRENCY)
    const [price, setPrice] = useState('')
    const [isConfirm, setIsConfirm] = useState(false)

    const [errors, setErrors] = useState({})

    const handleSubmit = async () => {
        try {
            setErrors({})

            const validator = new fieldsValidator()

            validator.addFields([
                validator.createField('price', String(price), [
                    getIsValueRule(),
                    getIsNotEmptyStringRule(),
                    getIsIntStringRule(),
                ]),
            ])

            const { isHasErrors, errors } = validator.validate()
            if (isHasErrors) {
                setErrors(errors)
                return
            }

            await onSubmit({
                product,
                currency,
                price: product.billingCycleValue === 12 ? price * 12 : price,
                isInflated: false,
            })

            return true
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
            throw err
        }
    }

    return (
        <FormModal
            headText="Add Price"
            subHeadText={`${product.name} (${product.productCode})`}
            successText="Price added successfully!"
            warningText={isNeedToConfirm ? "Don't forget sync price with Stripe!" : ''}
            actionText="Accept"
            onAction={() => handleSubmit()}
            isDisabledAction={isNeedToConfirm && !isConfirm}
            onClose={() => onClose()}
        >
            <FormBlock label={`Price (${currenciesSymbol[currency]} / Month)`}>
                <PriceNote price={price} billingCycle={product.billingCycleValue} currency={currency} />
                <Input
                    value={price}
                    type="number"
                    min={1}
                    error={errors.price}
                    onChange={value => {
                        setPrice(value)
                        setErrors(removeKeyFromObject(errors, 'price'))
                    }}
                />
            </FormBlock>
            {isNeedToConfirm && (
                <FormBlock>
                    <Checkbox
                        value={isConfirm}
                        label="I confirm that I am sober and this price is synced with Stripe"
                        onChange={value => setIsConfirm(value)}
                    />
                </FormBlock>
            )}
        </FormModal>
    )
}

export default AddPriceModal
